import { render, staticRenderFns } from "./card-exclusive.vue?vue&type=template&id=a27993d4&scoped=true&lang=pug&"
import script from "./card-exclusive.vue?vue&type=script&lang=js&"
export * from "./card-exclusive.vue?vue&type=script&lang=js&"
import style0 from "./card-exclusive.vue?vue&type=style&index=0&id=a27993d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27993d4",
  null
  
)

export default component.exports